import React from 'react';
import { FiSlash } from 'react-icons/fi';

import { Badge } from 'components/Badge';

/**
 * @typedef {Object} OptInNotConfirmedBadgeProps
 * @property {string?} className
 */

/**
 * Badge with the icon and text "Opted Out"
 *
 * @param {OptInNotConfirmedBadgeProps} props
 */
export function OptInNotConfirmedBadge({ className }) {
    return (
        <Badge className={className} type="danger">
            <FiSlash /> Opted In Not Confirmed
        </Badge>
    );
}
